import React, { useState } from "react";
import { Box, TextField, Button, Typography, IconButton } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  boxShadow: "none",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const CertificationsForm = ({ onChildData }) => {
  const [certifications, setCertifications] = useState([""]);

  const handleChange = (index, e) => {
    const updatedCertifications = [...certifications];
    updatedCertifications[index] = e.target.value;
    setCertifications(updatedCertifications);
    onChildData({ certifications: updatedCertifications});
  };

  const addCertification = () => {
    setCertifications([...certifications, ""]);
  };

  const removeCertification = (index) => {
    const updatedCertifications = certifications.filter((_, i) => i !== index);
    setCertifications(updatedCertifications);
    onChildData({ certifications: updatedCertifications});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const output = `certifications:\n${certifications
      .map((cert) => `  - "${cert}"`)
      .join("\n")}`;

    console.log(output);
    // Process certifications as needed
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3, pt: 0, pb: 2 }}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography variant="h6">Certifications</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {certifications.map((cert, index) => (
            <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
              <Grid size={10}>
                <Item>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="C1"
                    label="Certification Name"
                    value={cert}
                    onChange={(e) => handleChange(index, e)}
                    required
                  />
                </Item>
              </Grid>
              <Grid size={2}>
                <Item>
                  <IconButton
                    onClick={() => removeCertification(index)}
                    color="error"
                  >
                    <DeleteForeverIcon />
                  </IconButton>
                </Item>
              </Grid>
            </Grid>
          ))}
          <Button
            variant="outlined"
            onClick={addCertification}
            startIcon={<Add />}
            sx={{ mb: 2 }}
          >
            Add Certification
          </Button>
        </AccordionDetails>
      </Accordion>

      <Button type="submit" variant="contained" sx={{ display: "none" }}>
        Submit
      </Button>
    </Box>
  );
};

export default CertificationsForm;
